module.exports = __webpack_public_path__ + "assets/images/tutor.c8465fd9d8c97f109238cc0e7935075c.svg";